import { OptionCl } from "../../../components/select-cl"


export const domainIsmagType : OptionCl[] = [
    {id:"YES",      description:"Adherent Issuer"},
    {id:"PRG",      description:"Adherent Issuer for some programs only"},
    {id:"NONE",     description:"None Adherent Issuer"},
    {id:"FAILED",   description:"Failed Issuer for some programs only"}
]
